import React, { Component } from 'react';
import VForm from 'react-validation/build/form';
import VInput from 'react-validation/build/input';
import VButton from 'react-validation/build/button';
import validator from 'validator';
import axios from "axios";
import { appConfig } from '../../../../tools/AppConfig';
import Waiting from '../../../waiting';
import Logo from '../../../../../statics/img/aman/aman_logo.png';
import paymobLogo from "./../../../../../statics/img/esaypaisa/paymob.png";
import { dependencies } from '../../../../tools/Dependencies';
import Status from '../../components/IframeStatus/Status';
import './AmanV3.css'

let resend_setInterval; 

class AmanV3 extends Component {
    constructor(props){
        super(props)
        this.state = {
            user_data : {},
            step: 1,
            waiting: false,
            error: false,
            error_message: "",
            //Step 1 
            mobile_number : '',
            //Step 2 
            installment_plans: [],
            selected_plan: {},
            selected_plan_index : "",
            step_2_validation : false,
            //Step 3
            trnx_id: "",
            otp :"",
            trnx_id : "",
            resend: false,
            resend_counter: 60,
            // Status Screen
            status: null,
            status_message: "",
            redirection_url: ""
        }
    }
    componentDidMount(){
        const data = dependencies.decodePaymentToken(this.props.payment_token)
        this.setState({user_data : data})
    }
    // Validations
    requiredV = (value) => {
        if(validator.isEmpty(value)){
            return(
                // We can return string or jsx as the 'error' prop for the validated Component
                <div className="alert alert-danger" role="alert">
                    This field is required.
                </div>
            )
        }
    };
    phoneV = (value,props) => {
        if(props.isChanged === true){
            if(!!props.id){
                if(!validator.isNumeric(value) || value.length !== 11){
                    return <div className="alert alert-danger" role="alert">Please enter a valid phone number.</div>;
                }
            }
        }
    };
    otpV = (value,props) => {
        if(props.isChanged == true){
            if(!!props.id){
                if(!validator.isNumeric(value) || value.length !== 6 ){
                    return <div className="alert alert-danger" role="alert"> Please enter a valid OTP.</div>;
                }
            }
        }
    };
    // Logic
    handle_select_plan = (plan, index) => {
        let new_state = {...this.state}
        new_state.selected_plan = plan;
        new_state.selected_plan_index = index
        new_state.step_2_validation = true
        this.setState(new_state,()=>{
            console.log(new_state)
        })
    }
    start_resend_counter = () => {
        this.setState({resend: true});
        clearInterval(resend_setInterval);
        resend_setInterval = setInterval(()=>this.resend_counter_calc(), 1000)
    }
    resend_counter_calc = () => {
        if(this.state.resend_counter > 0){
            this.setState({resend_counter: this.state.resend_counter - 1});
        }else{
            clearInterval(resend_setInterval);
            this.setState({resend_counter: 60, resend: false});
        }
    }
    // Requests
    handlePhoneNumberSubmit = () => {
        this.setState({waiting: true}, ()=>{
            let url = appConfig.getServerUrl() + '/api/acceptance/aman_v3/installment-plans';
            let config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            };
            let data = {
                "payment_token": this.props.payment_token,
                "mobile_number": this.state.mobile_number
            }
            let jsonData = JSON.stringify(data);
            axios.post(
                url,
                jsonData,
                config
            )
            .then((resp)=>{
                this.setState({waiting: false, error: false, error_message:"", installment_plans: resp.data.plans ,step: 2});
            })
            .catch((err)=>{
                if(err.response.data && err.response.data.message){
                    this.setState({waiting: false, error: true, error_message: err.response.data.message});
                }else{
                    this.setState({waiting: false, error: true, error_message_message: "Something went wrong."});
                }
            });
        });
    }
    handleSendOtp = () => {
        this.setState({waiting: true}, ()=>{
            let url = appConfig.getServerUrl() + '/api/acceptance/payments/pay';
            let config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            };
            let data = {
                "source": {
                    "identifier": this.state.mobile_number,
                    "subtype": "AMANV3"
                },
                "payment_token": this.props.payment_token,
            }
            let jsonData = JSON.stringify(data);
            axios.post(
                url,
                jsonData,
                config
            )
            .then((resp)=>{
                this.setState({waiting: false, error: false, error_message: "", trnx_id : resp.data.id, step: 3}, ()=> {
                    this.start_resend_counter();
                });
            })
            .catch((err)=>{
                if(err.response.data && err.response.data.message){
                    this.setState({waiting: false, error: true, error_message: err.response.data.message});
                }else{
                    this.setState({waiting: false, error: true, error_message: "Something went wrong."});
                }
            });
        });
    }
    handleResendOtp = () => {
        this.setState({waiting: true}, ()=>{
            let url = appConfig.getServerUrl() + '/api/acceptance/aman_v3/resend-otp';
            let config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            };
            let data = {
                "payment_token": this.props.payment_token,
                "transaction" : this.state.trnx_id
            }
            let jsonData = JSON.stringify(data);
            axios.post(
                url,
                jsonData,
                config
            )
            .then((resp)=>{
                this.setState({waiting : false, error : false, error_message : "", otp: ""},()=>{
                    this.start_resend_counter();
                })
            })
            .catch((err)=>{
                if(err.response.data && err.response.data.message){
                    this.setState({waiting: false, error: true, error_message: err.response.data.message});
                }else{
                    this.setState({waiting: false, error: true, error_message: "Something went wrong."});
                }
            });
        });
    }
    handleOtpSubmit = () => {
        this.setState({waiting: true}, ()=>{
            let url = appConfig.getServerUrl() + '/api/acceptance/aman_v3/confirm';
            let config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            };
            let data = {
                "payment_token": this.props.payment_token,
                "transaction" : this.state.trnx_id,
                "otp" : this.state.otp,
                "monthly_amount":this.state.selected_plan.MonthlyAmount,
                "months":this.state.selected_plan.Months
            }
            let jsonData = JSON.stringify(data);
            axios.post(
                url,
                jsonData,
                config
            )
            .then((resp)=>{
                if(resp.data.success === true && resp.data.pending === false){
                    // success
                    this.setState({waiting: false, error: false, error_message: "", status: "success", redirection_url: resp.data.redirection_url});
                }else if(resp.data.success === false && resp.data.pending === true){
                    // pending
                    this.setState({waiting: false, error: false, error_message: "", status: "pending", redirection_url: resp.data.redirection_url});
                }else if(resp.data.success === false && resp.data.pending === false){
                    // fail
                    this.setState({waiting: false, error: false, error_message: "", status: "fail", redirection_url: resp.data.redirection_url, status_message: resp.data["data.message"]});
                }
            })
            .catch((err)=>{
                if(err.response.data && err.response.data.message){
                    this.setState({waiting: false, error: true, error_message: err.response.data.message});
                }else{
                    this.setState({waiting: false, error: true, error_message: "Something went wrong."});
                }
            });
        });
    }
    // render
    renderStep1 = () => (
        <div className="aman_content">
            <h3>Your purchase amount is {this.state.user_data.amount_cents/100} {this.state.user_data.currency}, Please enter your phone number to complete the payment.</h3>
            <VForm onSubmit = {()=>this.handlePhoneNumberSubmit()}>
                <div className="iframe_input">
                    <VInput
                        type = 'text'
                        name = 'mobile_number'
                        id="mobile_number"
                        maxLength="11"
                        placeholder = "Phone number"
                        value={this.state.mobile_number}
                        onChange={(e)=>this.setState({mobile_number: e.target.value})}
                        validations={[this.requiredV,this.phoneV]} 
                    />
                </div>
                <a href="https://www.amanshops.com/Merchants/Pages/PaymobLandingPage.aspx" className="register_text">If you're not Aman customer, click here to register</a>
                {this.state.error &&
                    <div className="aman_error">
                        {this.state.error_message}
                    </div>
                }
                <VButton>Next</VButton>
            </VForm>
        </div>
    )
    renderStep2 = () => (
        <div className="aman_content">
            <h3>Select Installment Plan</h3>
            <div className="installment_plans_container">
                {this.state.installment_plans.map((plan, index) => (
                    <div key={index} onClick={()=>this.handle_select_plan(plan, index)} className={`${this.state.selected_plan_index === index ? "selected" : ""}`}>
                        <label>
                            <p>{plan.Months} Months</p>
                            <span>{plan.MonthlyAmount} {this.state.user_data.currency} / Month </span>  
                            <span>Admin Fees {Number(plan.AdminFees).toFixed(2)} {this.state.user_data.currency}</span>
                        </label>
                    </div>
                ))}
            </div>
            {this.state.error &&
                <div className="aman_error">
                    {this.state.error_message }
                </div>
            }
            <button disabled={!this.state.step_2_validation} onClick={this.handleSendOtp}>Next</button>
        </div>
    )
    renderStep3 = () => (
        <div className="aman_content">
            <h3>Please confirm your OTP</h3>
            <VForm onSubmit = {()=>this.handleOtpSubmit()}>
                <div className="iframe_input">
                    <VInput
                        type = 'text'
                        name = 'otp'
                        id="otp"
                        maxLength="6"
                        value={this.state.otp}
                        placeholder = "OTP"
                        onChange={(e)=>this.setState({otp: e.target.value})}
                        validations={[this.requiredV,this.otpV]} 
                    />
                </div>
                <div className="resend_otp">
                    <p>
                        Didn’t receive code?
                        {this.state.resend?
                            <span>Send again in<span>{this.state.resend_counter}</span> sec.</span>
                        :
                            <span className="send_again" onClick={()=>this.handleResendOtp()}>Send again</span>
                        }
                    </p>
                </div>
                {this.state.error &&
                    <div className="aman_error">
                        {this.state.error_message}
                    </div>
                }
                <VButton>Submit</VButton>
            </VForm>
        </div>
    )
    renderBody = () =>(
        <div className="aman_container">
            {this.state.status === null &&
                <div className="aman_header">
                    <img src={Logo} alt="Aman"/>
                </div>
            }
            {this.state.waiting ?
                <Waiting height='200px' />
            :
                this.state.status === null ?
                    <>
                        {this.state.step === 1 && this.renderStep1()}
                        {this.state.step === 2 && this.renderStep2()}
                        {this.state.step === 3 && this.renderStep3()}
                    </>
                :
                    <Status
                        status={this.state.status}
                        status_message={this.state.status_message}
                        gateway_name="Aman"
                        redirection_url={this.state.redirection_url}
                    />
            }   
            <div className="aman_footer">
                <span>Powered by</span>
                <img src={paymobLogo} alt="Paymob" className="paymob" />
            </div>            
        </div>
    )

    render(){
        return(
            <div className="aman">
                {this.renderBody()}
            </div>
        )
    }
}
export default AmanV3